export default "__VITE_ASSET__CAW8AnDr__"